import React, { useEffect } from "react";
import { DelDatePicker, customDatePicker } from "../../common/DelDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import { TimePickerInput } from "../../common/TimePickerInput";
import styles from "./jsaConfinedSpaceInfoComponents.module.css";

// Helper function to get field error for Confined Space fields
const getConfinedSpaceFieldError = (autosaveErrors, fieldName) => {
  const key = `jsa_confined_space.${fieldName}`;
  return autosaveErrors?.fieldErrors?.[key] || null;
};

// JSA V1 Confined Space Entry Yes/No section
export const CseEntryYesNoSection = ({ callbacks }) => {
  // Handling the Checking the Yes checkbox
  const handleCseEntryYes = (e) => {
    callbacks.v1Actions.updateCseEntryYes(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };
  // Handling the Checking the No checkbox
  const handleCseEntryNo = (e) => {
    callbacks.v1Actions.updateCseEntryNo(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  return (
    <div className={styles.cseInfoSection}>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowText}>
          <p>Will anyone be entering the confined space?</p>
        </div>
      </div>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowInputContainer}>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>Yes</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.cseEntryYes}
              onChange={handleCseEntryYes}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>No</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.cseEntryNo}
              onChange={handleCseEntryNo}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// JSA V1 Confined Space EWI/Client Permit
export const CsePermitEwiClientPermitSection = ({ callbacks }) => {
  // Handling the checking of the EWI Permit row
  const handleCsePermitEwi = (e) => {
    callbacks.v1Actions.updateCsePermitEwi(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  // Handling the checking of the Client Permit row
  const handleCsePermitClient = (e) => {
    callbacks.v1Actions.updateCsePermitClient(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  return (
    <div className={styles.cseInfoSection}>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowText}>
          <p>Check which permit program will be used?</p>
        </div>
      </div>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowInputContainer}>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>EWI Permit</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.csePermitEwi}
              onChange={handleCsePermitEwi}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>Client Permit</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.csePermitClient}
              onChange={handleCsePermitClient}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// JSA V1 Confined Space client approved/not approved section
export const CsePermitClientApprovedSection = ({ callbacks }) => {
  // Handling the checking of the Yes checkbox
  const handleCsePermitClientApproved = (e) => {
    callbacks.v1Actions.updateCsePermitClientApproved(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  // Handling the checking of the No checkbox
  const handleCsePermitClientNotApproved = (e) => {
    callbacks.v1Actions.updateCsePermitClientNotApproved(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  return (
    <div className={styles.cseInfoSection}>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowText}>
          <p>
            If a client permit is required, has this permit been approved by
            EWI?
          </p>
        </div>
      </div>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowInputContainer}>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>Yes</label>
            <input
              type="checkbox"
              checked={
                callbacks.jsaData.jsaConfinedSpace.csePermitClientApproved
              }
              onChange={handleCsePermitClientApproved}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>No</label>
            <input
              type="checkbox"
              checked={
                callbacks.jsaData.jsaConfinedSpace.csePermitClientNotApproved
              }
              onChange={handleCsePermitClientNotApproved}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// JSA V1 CSE Admin section
export const CseAdminSection = ({ callbacks }) => {
  // Handling the checking of the Admin Notified Yes
  const handleCseAdminNotifiedYes = (e) => {
    callbacks.v1Actions.updateCseAdminNotifiedYes(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  // Handling the checking of the Admin Notified No
  const handleCseAdminNotifiedNo = (e) => {
    callbacks.v1Actions.updateCseAdminNotifiedNo(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  // Handling the time of notification
  const handleCseAdminNotificationTime = (time) => {
    callbacks.v1Actions.updateCseAdminNotificationTime(
      callbacks.jsaData,
      time,
      callbacks.emitPatch,
    );
  };
  // Handling the date of notification
  const handleCseAdminNotificationDate = (date) => {
    callbacks.v1Actions.updateCseAdminNotificationDate(
      callbacks.jsaData,
      date,
      callbacks.emitPatch,
    );
  };

  // Handling the name of the CSE Administrator (local state only on onChange)
  const handleCseAdminName = (e) => {
    callbacks.v1Actions.updateCseAdminName(
      callbacks.jsaData,
      e.target.value,
      null,
    ); // Don't emit on every keystroke
  };

  // Handle blur - send patch to server
  const handleCseAdminNameBlur = (e) => {
    callbacks.v1Actions.updateCseAdminName(
      callbacks.jsaData,
      e.target.value,
      callbacks.emitPatch,
    ); // Emit on blur
  };

  return (
    <div className={styles.cseInfoSection}>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowText}>
          <p>Has the CSE Administrator been notified?</p>
        </div>
      </div>
      <div className={styles.cseInfoRow}>
        <div className={styles.cseInfoRowInputContainer}>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>Yes</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedYes}
              onChange={handleCseAdminNotifiedYes}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
          <div className={styles.cseInfoRowInput}>
            <label className={styles.cseInfoRowLabel}>No</label>
            <input
              type="checkbox"
              checked={callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedNo}
              onChange={handleCseAdminNotifiedNo}
              className={styles.cseInfoRowInputCheckbox}
              disabled={callbacks.jsaMode === "view"}
            />
          </div>
        </div>
      </div>
      <div
        className={`${styles.cseConditionalSections} ${
          callbacks.jsaV1.confinedSpace.showAdminNotifiedSection
            ? styles.cseConditionalSectionsVisible
            : ""
        }`}
      >
        <div className={styles.cseInfoRow}>
          <div className={styles.cseInfoRowText}>
            <p>
              If yes, add the time of notification and name of the CSE
              Administrator below:
            </p>
          </div>
        </div>
        <div className={styles.dateTimeContainer}>
          <div className={styles.InfoRowInput}>
            <label className={styles.cseInfoRowLabel}>
              Time of Notification
            </label>
            <TimePickerInput
              value={
                callbacks.jsaData.jsaConfinedSpace.cseAdminNotificationTime
              }
              onChange={handleCseAdminNotificationTime}
            />
          </div>
          <div className={styles.InfoRowInput}>
            <label className={styles.cseInfoRowLabel}>
              Date of Notification
            </label>
            <DelDatePicker
              selected={
                callbacks.jsaData.jsaConfinedSpace.cseAdminNotificationDate
              }
              onChange={handleCseAdminNotificationDate}
              disabled={callbacks.jsaMode === "view"}
              isClearable={true}
              onFocus={(e) => (e.target.readOnly = true)}
              withPortal
              portalId="date-picker-portal"
              dateFormat="MM/dd/yyyy"
              placeholderText="Select a date"
              className={styles.cseInfoRowInputText}
            />
          </div>
          <div className={styles.InfoRowInput}>
            <label className={styles.cseInfoRowLabel}>
              Name of CSE Administrator
            </label>
            {(() => {
              const adminNameError = getConfinedSpaceFieldError(
                callbacks.autosaveErrors,
                "cse_admin_name",
              );
              return (
                <>
                  <input
                    type="text"
                    value={callbacks.jsaData.jsaConfinedSpace.cseAdminName}
                    onChange={handleCseAdminName}
                    onBlur={handleCseAdminNameBlur}
                    className={`${styles.cseInfoRowInputText} ${adminNameError ? styles.inputError : ""}`}
                    disabled={callbacks.jsaMode === "view"}
                  />
                  {adminNameError && (
                    <span className={styles.errorText}>{adminNameError}</span>
                  )}
                </>
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

// JSA V1 Confined Space Breaking Plane Yes/No section
export const CseBreakingPlaneYesNoSection = ({ callbacks }) => {
  // Handling the checking of the Yes checkbox
  const handleCseBreakingPlaneYes = (e) => {
    callbacks.v1Actions.updateCseBreakingPlaneYes(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  // Handling the checking of the No checkbox
  const handleCseBreakingPlaneNo = (e) => {
    callbacks.v1Actions.updateCseBreakingPlaneNo(
      callbacks.jsaData,
      e.target.checked,
      callbacks.emitPatch,
    );
  };

  return (
    <>
      <div className={styles.cseInfoSection}>
        <div className={styles.cseInfoRow}>
          <div className={styles.cseInfoRowText}>
            <p>
              Will you have to break the plane of the vessel at any point during
              the operation?
            </p>
          </div>
        </div>
        <div className={styles.cseInfoRow}>
          <div className={styles.cseInfoRowInputContainer}>
            <div className={styles.cseInfoRowInput}>
              <label className={styles.cseInfoRowLabel}>Yes</label>
              <input
                type="checkbox"
                checked={callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneYes}
                onChange={handleCseBreakingPlaneYes}
                className={styles.cseInfoRowInputCheckbox}
                disabled={callbacks.jsaMode === "view"}
              />
            </div>
            <div className={styles.cseInfoRowInput}>
              <label className={styles.cseInfoRowLabel}>No</label>
              <input
                type="checkbox"
                checked={callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneNo}
                onChange={handleCseBreakingPlaneNo}
                className={styles.cseInfoRowInputCheckbox}
                disabled={callbacks.jsaMode === "view"}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${styles.cseConditionalSections} ${
          callbacks.jsaV1.confinedSpace.showCseBreakingPlaneSection
            ? styles.cseConditionalSectionsVisible
            : ""
        }`}
      >
        <CsePermitEwiClientPermitSection callbacks={callbacks} />

        {callbacks.jsaV1.confinedSpace.showCsePermitClientSection && (
          <CsePermitClientApprovedSection callbacks={callbacks} />
        )}

        <CseAdminSection callbacks={callbacks} />
      </div>
    </>
  );
};

// JSA V1 Confined Space Info Tab
export const JsaConfinedSpaceInfoTab = ({ callbacks }) => {
  // CSE Entry Section - Show when "Yes" is checked for confined space entry
  useEffect(() => {
    if (callbacks.jsaData.jsaConfinedSpace.cseEntryYes) {
      if (!callbacks.jsaV1.confinedSpace.showCseEntrySection) {
        callbacks.v1Actions.updateCseEntryYes(callbacks.jsaData, true);
      }
    } else if (callbacks.jsaData.jsaConfinedSpace.cseEntryNo) {
      if (callbacks.jsaV1.confinedSpace.showCseEntrySection) {
        callbacks.v1Actions.updateCseEntryNo(callbacks.jsaData, true);
      }
    }
  }, [
    callbacks.jsaData.jsaConfinedSpace.cseEntryYes,
    callbacks.jsaData.jsaConfinedSpace.cseEntryNo,
    callbacks.jsaV1.confinedSpace.showCseEntrySection,
  ]);

  // CSE Breaking Plane Section - Show when "Yes" is checked for breaking plane
  useEffect(() => {
    if (callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneYes) {
      if (!callbacks.jsaV1.confinedSpace.showCseBreakingPlaneSection) {
        callbacks.v1Actions.updateCseBreakingPlaneYes(callbacks.jsaData, true);
      }
    } else if (callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneNo) {
      if (callbacks.jsaV1.confinedSpace.showCseBreakingPlaneSection) {
        callbacks.v1Actions.updateCseBreakingPlaneNo(callbacks.jsaData, true);
      }
    }
  }, [
    callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneYes,
    callbacks.jsaData.jsaConfinedSpace.cseBreakingPlaneNo,
    callbacks.jsaV1.confinedSpace.showCseBreakingPlaneSection,
  ]);

  // CSE Permit Client Section - Show when client permit is checked
  useEffect(() => {
    if (callbacks.jsaData.jsaConfinedSpace.csePermitClient) {
      if (!callbacks.jsaV1.confinedSpace.showCsePermitClientSection) {
        callbacks.v1Actions.updateCsePermitClient(callbacks.jsaData, true);
      }
    }
  }, [
    callbacks.jsaData.jsaConfinedSpace.csePermitClient,
    callbacks.jsaV1.confinedSpace.showCsePermitClientSection,
  ]);

  // Admin Notified Section - Show when admin notification "Yes" is checked
  useEffect(() => {
    if (callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedYes) {
      if (!callbacks.jsaV1.confinedSpace.showAdminNotifiedSection) {
        callbacks.v1Actions.updateCseAdminNotifiedYes(callbacks.jsaData, true);
      }
    } else if (callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedNo) {
      if (callbacks.jsaV1.confinedSpace.showAdminNotifiedSection) {
        callbacks.v1Actions.updateCseAdminNotifiedNo(callbacks.jsaData, true);
      }
    }
  }, [
    callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedYes,
    callbacks.jsaData.jsaConfinedSpace.cseAdminNotifiedNo,
    callbacks.jsaV1.confinedSpace.showAdminNotifiedSection,
  ]);

  return (
    <div className={styles.confinedSpaceInfoTab}>
      <CseEntryYesNoSection callbacks={callbacks} />
      <div
        className={`${styles.cseConditionalSections} ${
          callbacks.jsaV1.confinedSpace.showCseEntrySection
            ? styles.cseConditionalSectionsVisible
            : ""
        }`}
      >
        <CseBreakingPlaneYesNoSection callbacks={callbacks} />
      </div>
    </div>
  );
};
